import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';

import { IAppState } from '../../store/interface/app.state.interface';
import { IUser } from '../../core/interfaces/user.interface';
import { IResponse } from '../../shared/interfaces/response.interface';
import { ISignIn, IToken } from '../interfaces/auth.interface';
import { TokenStoreService } from '../../core/services/token-store.service';
import * as UserActions from '../../store/user/user.actions';

@Injectable()
export class AuthService {
    private readonly http = inject(HttpClient);
    private readonly store = inject(Store<IAppState>);
    private readonly tokenStore = inject(TokenStoreService);
    private readonly signInUrl = '/auth/sign-in';
    private readonly codeUrl = '/auth/sign-in/code';
    private readonly meUrl = '/auth/me';
    private readonly signOutUrl = '/auth/sign-out';

    async signIn(email: string, password: string): Promise<string> {
        return firstValueFrom(
            this.http.post<IResponse<ISignIn>>(this.signInUrl, { email, password }),
        ).then((res) => res.data.otpId);
    }

    async resendCode(otpId: string): Promise<void> {
        await firstValueFrom(this.http.post(`${this.codeUrl}/resend`, { otpId }));
    }

    async verifyCode(otpId: string, code: string): Promise<void> {
        const { token, person, business, role } = await firstValueFrom(
            this.http.post<IResponse<IToken>>(this.codeUrl, { otpId, code }),
        ).then((res) => res.data);

        this.tokenStore.save(token);
        this.store.dispatch(UserActions.setLoggedInUser({ user: { person, business, role } }));
    }

    async fetchLoggedInUser(): Promise<void> {
        return firstValueFrom(this.http.get<IResponse<IUser>>(this.meUrl)).then((res) => {
            this.store.dispatch(UserActions.setLoggedInUser({ user: res.data }));
        });
    }

    async logout(): Promise<void> {
        await firstValueFrom(this.http.post(this.signOutUrl, {}));
    }
}
